import { z } from 'zod';

/** Validates a password according to DAYMADE's password rules. Returns true if the password is acceptable */
export function isValidPassword(password: string | undefined): boolean {
  if (!password) {
    return false;
  }
  // At least one number/uppercase character. At least 8 characters.
  const expression = /((?=.*\W|_)|(?=.*\d)|(?=.*[A-Z])).{8,}/;
  return expression.test(password);
}

/** The message to be shown when a password does not meet the requirements of isValidPassword above */
export const invalidPasswordMessage =
  'Please create a password with at least 8 characters and a number/special character.';

export const maxValidNameLength = 100;

// Allow letters from any alphabet plus common real-name separators.
export const validNameRegex = /^[\p{L}\p{M}]+(?:[ '\u2019-][\p{L}\p{M}]+)*$/u;

export const normalizeValidName = (name: string) => name.trim();

export function isValidName(
  name: string | undefined | null,
): name is string {
  if (typeof name !== 'string') {
    return false;
  }

  const normalizedName = normalizeValidName(name);

  return (
    normalizedName.length > 0 &&
    normalizedName.length <= maxValidNameLength &&
    validNameRegex.test(normalizedName)
  );
}

export const invalidValidNameMessage =
  'Please provide a valid name using letters only, with spaces, hyphens, or apostrophes if needed.';

export const zValidName = z
  .string()
  .trim()
  .min(1, invalidValidNameMessage)
  .max(maxValidNameLength, invalidValidNameMessage)
  .regex(validNameRegex, invalidValidNameMessage);
